import React from 'react'

import { useFormatMessage } from '@masfront/common-i18n'

import { Box, Typography, makeStyles, useTheme } from '@material-ui/core'
import HomeIcon from '@material-ui/icons/Home'
import StarIcon from '@material-ui/icons/Star'
import WorkIcon from '@material-ui/icons/Work'

import useBrandStyles from './SegmentSignBrandStyles'

import { getSegmentText } from '~/customer/helpers/customer.helpers'
import { CustomerSector } from '~/customer/model/customer.model'

interface SegmentSignProps {
  type: CustomerSector
  customerId: string
}

const useStyles = makeStyles((theme) => ({
  segmentText: {
    verticalAlign: 'middle',
    padding: theme.spacing(0.5, 3),
    display: 'flex',
  },
}))

const SegmentSign: React.FC<SegmentSignProps> = ({ type, customerId }) => {
  const brandClasses = useBrandStyles({ type })
  const classes = useStyles()
  const t = useFormatMessage()
  const theme = useTheme()

  const segmentInfo = {
    [CustomerSector.RESIDENTIAL]: {
      literal: getSegmentText(CustomerSector.RESIDENTIAL, t),
      icon: <HomeIcon fontSize="inherit" />,
    },
    [CustomerSector.COMPANY]: {
      literal: getSegmentText(CustomerSector.COMPANY, t),
      icon: <StarIcon fontSize="inherit" />,
    },
    [CustomerSector.HORECA]: {
      literal: getSegmentText(CustomerSector.HORECA, t),
      icon: <WorkIcon fontSize="inherit" />,
    },
    [CustomerSector.SELF_EMPLOYED]: {
      literal: getSegmentText(CustomerSector.SELF_EMPLOYED, t),
      icon: <WorkIcon fontSize="inherit" />,
    },
    [CustomerSector.UNKNOWN]: {
      literal: getSegmentText(CustomerSector.UNKNOWN, t),
      icon: null,
    },
  }

  return (
    <Box
      borderRadius={theme.spacing(1)}
      color="white"
      display="inline-flex"
      className={brandClasses.root}
    >
      <Typography className={classes.segmentText} variant="h5">
        {segmentInfo[type].icon ? (
          <Box display="inline-flex" pr={2} fontSize={16}>
            {segmentInfo[type].icon}
          </Box>
        ) : (
          ''
        )}
        {segmentInfo[type].literal}
        {customerId ? ` - ${customerId}` : ''}
      </Typography>
    </Box>
  )
}
export default SegmentSign
